import * as React from 'react';
import { useFormikContext } from 'formik';

import { Range, Title } from '@/shared/ui/elements';

import NoPreferenceButton from './NoPreferenceButton';

import {
  RangeContainer,
  ButtonContainer,
} from '../ShiftPreferencesModal.styled';
import NextButton from './NextButton';

export const SelectDistance = ({ slick, forEdit }) => {
  const rangeRef = React.useRef();
  const { setFieldValue } = useFormikContext();

  const handleNoPreference = () => {
    rangeRef.current.setValue(150);
    slick.current?.slickNext();
  };

  return (
    <div>
      <Title>How far are you willing to travel?</Title>
      <RangeContainer>
        <Range
          ref={rangeRef}
          name="distance"
          min="0"
          max="150"
          step="25"
          initialLabel="0 MILES"
          finalLabel="150 MILES +"
          onChange={(event) => setFieldValue('distance', event.target.value)}
        />
      </RangeContainer>
      <ButtonContainer>
        <NextButton forEdit={forEdit} slick={slick} />
        {!forEdit && (
          <NoPreferenceButton
            afterOnClick={handleNoPreference}
            field="distance"
            defaultValue="150"
          />
        )}
      </ButtonContainer>
    </div>
  );
};
